import { createContext} from "react";
import { useCookies } from "react-cookie";
const AuthContext = createContext({});

export const AuthProvider = ({ children }: any) => {
  const [cookie, setCookie, removeCookie] = useCookies<any>();
  return (
    <AuthContext.Provider value={{ cookie, setCookie, removeCookie }}>
      {" "}
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
